var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLastUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.1875C13.4601 0.187789 11.441 0.597413 9.56228 1.39211C7.68356 2.18682 5.9834 3.35044 4.5625 4.81406V0.1875H2.375V8.9375H11.125V6.75H5.74375C7.79566 4.46985 10.5814 2.98042 13.6171 2.54038C16.6529 2.10034 19.7469 2.73749 22.3617 4.34117C24.9766 5.94485 26.9472 8.41375 27.9313 11.3191C28.9153 14.2244 28.8507 17.3827 27.7485 20.2453C26.6464 23.108 24.5765 25.4942 21.8982 26.9895C19.2198 28.4848 16.1024 28.9948 13.0872 28.4309C10.072 27.867 7.34953 26.2649 5.39265 23.9027C3.43577 21.5405 2.36808 18.5675 2.375 15.5H0.1875C0.1875 18.5285 1.08556 21.489 2.76812 24.0072C4.45068 26.5253 6.84217 28.4879 9.64016 29.6469C12.4382 30.8059 15.517 31.1091 18.4873 30.5183C21.4577 29.9274 24.1861 28.4691 26.3276 26.3276C28.4691 24.1861 29.9274 21.4577 30.5183 18.4873C31.1091 15.517 30.8059 12.4382 29.6469 9.64016C28.4879 6.84217 26.5253 4.45068 24.0072 2.76812C21.489 1.08556 18.5285 0.1875 15.5 0.1875Z",
    fill: "#FF7C33"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastUpdate);
export default __webpack_public_path__ + "static/media/last-update.1faf7552.svg";
export { ForwardRef as ReactComponent };